


























import { Vue, Component, Prop } from 'vue-property-decorator';
import ElapsedTime from './ElapsedTime.vue';
import ButtonInput from '../../components/ui/ButtonInput.vue';
import ExtraKeyboard from '../../components/ui/ExtraKeyboard.vue';
import CompletedCounter from './CompletedCounter.vue';
import QuizCommand from '@/types/QuizCommand';
import messageBus from '../../utils/MessageBus';

// noinspection JSUnusedGlobalSymbols
@Component({
  components: {
    ElapsedTime,
    ButtonInput,
    ExtraKeyboard,
    CompletedCounter,
  },
})
export default class QuizNav extends Vue {
  disabled: boolean = true;

  // TODO: stat type
  @Prop() stats!: object;

  // advance to next word
  // noinspection JSMethodCanBeStatic
  skipWord(): void { // eslint-disable-line class-methods-use-this
    messageBus.$emit('quizCommand', QuizCommand.Skip);
  }

  // go back to previous word
  // noinspection JSMethodCanBeStatic
  previousWord(): void { // eslint-disable-line class-methods-use-this
    messageBus.$emit('quizCommand', QuizCommand.Previous);
  }

  onEnableInput(isEnabled: boolean) {
    this.disabled = !isEnabled;
  }

  // noinspection JSUnusedGlobalSymbols
  mounted() {
    // handler to enable/disable input
    messageBus.$on('enableInput', this.onEnableInput);
  }

  // noinspection JSUnusedGlobalSymbols
  beforeDestroy() {
    messageBus.$off('enableInput', this.onEnableInput);
  }
}
